/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import PropTypes from "prop-types";
import React from "react";
import { ListComponent } from "@quintype/arrow";
import get from "lodash/get";
import "./search-page.m.css";

export const SearchPageResults = ({ collection, config, getMoreStories, limit, hideLoadmore, builderConfig }) => {
  const { "pagebuilder-config": pbconfig, "theme-attributes": themeAttributes } = config;
  const pbUpdatedConfig = builderConfig || pbconfig;
  const pbSearchConfig = get(pbUpdatedConfig, ["search", "pageSetting", "searchResultsConfig"], {});
  const sectionTagTemplate = get(
    pbUpdatedConfig,
    ["general", "rows", "sectionTag", "template"],
    get(pbSearchConfig, ["sectionTagTemplate"], "solid")
  );
  const footerButton = get(pbSearchConfig, ["footerButton"], "SubsequentLoadCount");
  const showRowTitle = false;
  const fallbackImageUrl = get(
    pbUpdatedConfig,
    ["general", "fallbackImage", "url"],
    get(themeAttributes, ["imageFallbackUrl"])
  );
  const { enablePremiumStoryIcon = false, iconColor = "#F7B500", iconStyle = "star" } = get(
    pbUpdatedConfig,
    ["general", "rows", "premiumStoryIcon"],
    {}
  );
  const premiumStoryIconConfig = { enablePremiumStoryIcon, iconColor, iconStyle };

  const { enableLocalization = false, localizedElements = {} } = get(pbUpdatedConfig, ["general", "localization"], {});

  const { timeToRead, months, meridiem } = localizedElements;
  const localizationConfig = enableLocalization
    ? { localizedTimeToRead: timeToRead, localizedMonths: months, localizedMeridiem: meridiem }
    : {};

  return (
    <ListComponent
      collection={collection}
      config={{
        ...pbSearchConfig,
        sectionTagTemplate,
        showRowTitle,
        footerButton,
        fallbackImageUrl,
        ...premiumStoryIconConfig,
        localizationConfig
      }}
      getMoreStories={getMoreStories}
      hideButton={hideLoadmore}
      limit={limit}
    />
  );
};

SearchPageResults.propTypes = {
  collection: PropTypes.any,
  getMoreStories: PropTypes.func,
  limit: PropTypes.number,
  hideLoadmore: PropTypes.bool,
  builderConfig: PropTypes.object,
  config: PropTypes.shape({
    collectionNameBorderColor: PropTypes.string,
    borderColor: PropTypes.string,
    theme: PropTypes.string,
    border: PropTypes.string,
    collectionNameTemplate: PropTypes.string,
    footerButton: PropTypes.string,
    initialLoadCount: PropTypes.string,
    getLoadMore: PropTypes.func,
    "pagebuilder-config": PropTypes.object,
    "theme-attributes": PropTypes.object
  }),
  getMoreStories: PropTypes.func,
  limit: PropTypes.number,
  hideLoadmore: PropTypes.func,
  builderConfig: PropTypes.object
};
